/**
 * Las columnas de la grilla de Combustibles, para `useColumnVisibility` (VEC-3693 fase 3).
 *
 * *** EL ORDEN ES EL DEL `thead`. *** Es el orden en que el selector las lista, y además es
 * lo que mantiene alineados el encabezado y las filas: las dos recorren esta misma lista.
 *
 * DOS EJES, que conviene no confundir (ver docs/design-system/grid-column-selector.md):
 *  - `enabled`  -> la columna EXISTE para este cliente. Sale de la config, y si está en false
 *                  la columna no se ve ni aparece en el selector.
 *  - visibilidad -> de las que existen, cuáles eligió ver el usuario. Es lo que persiste el
 *                  hook, por NOMBRE y no por índice.
 *
 * Las cuatro `fixed` son las que no tienen título —el check de selección masiva, el embudo de
 * estado, el separador— y la de acciones: ocultarlas dejaría la fila sin forma de operarla, y
 * en el selector aparecerían como casillas en blanco.
 */
export const COMBUSTIBLES_COLUMNAS_STORAGE_KEY = 'CombustiblesGrid_columnas';

/**
 * @param flags los gates de config YA RESUELTOS, en el render 0. Si se calculan en un efecto,
 *              durante el primer render la columna no existe y la visibilidad restaurada se
 *              aplica sobre una lista distinta.
 */
export const buildCombustiblesColumns = (flags) => {
	const f = flags || {};

	return [
		{ name: 'seleccion', fixed: true },
		{ name: 'dominio', messageId: 'combustiblesGrid.column.dominio.title', label: 'Dominio' },
		{ name: 'vin', label: 'VIN' },
		{
			name: 'unidad',
			messageId: 'combustiblesGrid.column.unidad.title',
			label: 'Unidad',
			enabled: f.unidad === true,
		},
		// La del embudo de estado: no tiene título y la fila la renderiza con `component="th"`.
		{ name: 'estadoCarga', fixed: true },
		{ name: 'controles', messageId: 'combustiblesGrid.column.controles.title', label: 'Controles' },
		{ name: 'fechaHoraCarga', messageId: 'combustiblesGrid.column.fecha_hora.title', label: 'Fecha y Hora' },
		{
			name: 'saldoTarjeta',
			messageId: 'combustiblesGrid.column.tarjeta_saldo.title',
			label: 'Saldo Tarjeta',
			enabled: f.saldoTarjeta === true,
		},
		{ name: 'utilizacion', messageId: 'combustiblesGrid.column.utilizacion.title', label: 'Utilización' },
		{ name: 'tipo', messageId: 'combustiblesGrid.column.tipo.title', label: 'Tipo' },
		{ name: 'litros', messageId: 'combustiblesGrid.column.litros.title', label: 'Litros' },
		{ name: 'total', messageId: 'combustiblesGrid.column.total.title', label: 'Total' },
		{ name: 'precioLitro', messageId: 'combustiblesGrid.column.precio_litro.title', label: 'Precio por Litro' },
		{ name: 'lugarCarga', messageId: 'combustiblesGrid.column.lugar_carga.title', label: 'Lugar de Carga' },
		{
			name: 'origen',
			messageId: 'combustiblesGrid.column.origen.title',
			label: 'Origen',
			enabled: f.origen === true,
		},
		{ name: 'responsableCarga', messageId: 'combustiblesGrid.column.responsable_carga.title', label: 'Responsable de carga' },
		{
			// Una sola celda con los dos rendimientos, LT/100Km y Kms/LT, como viene de antes.
			name: 'rendimiento',
			messageId: 'combustiblesGrid.column.rendimiento.title',
			label: 'Rendimiento',
		},
		{ name: 'costoKm', messageId: 'combustiblesGrid.column.costo_km.title', label: 'Costo/Km' },
		{
			name: 'base',
			messageId: 'combustiblesGrid.column.base.title',
			label: 'Base',
			enabled: f.base === true,
		},
		{
			name: 'conductor',
			messageId: 'combustiblesGrid.column.conductor.title',
			label: 'Conductor',
			enabled: f.conductor === true,
		},
		{ name: 'proveedor', messageId: 'combustiblesGrid.column.proveedor.title', label: 'Proveedor' },
		{ name: 'acciones', fixed: true },
	];
};
